<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("terms") }}
    </h1>

    <span v-if="lang_fplus == 'greek'">
      <terms-paydash-greek />
    </span>

    <span v-if="countryCode == 'cz'">
      <terms-czech v-if="lang_fplus == 'czech'" />
      <terms-english v-else />
    </span>
  </div>
</template>

<script>
import TermsGRPaydashGreek from "./TermsGRPaydashGreek";
import TermsEnglish from "./TermsEnglish";
import TermsCzech from "./TermsCzech";

import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_fplus", "countryCode"]),
  components: {
    "terms-paydash-greek": TermsGRPaydashGreek,
    TermsEnglish,
    TermsCzech,
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/funplus/Terms.vue